import moment from 'moment';
import {useEffect} from 'react';
import {Platform} from 'react-native';
import RNPrint from 'react-native-print';

export default async function CheckoutBill({rdat, dat1}) {
  let totTariff = 0,
    totExtbed = 0,
    totDisc = 0,
    totTax1 = 0,
    totTax2 = 0,
    totFnB = 0,
    totOthers = 0,
    tot = 0,
    totAdv = 0;

  const formatDate = d => moment(d, 'YYYY/MM/DD HH:mm:ss').format('DD-MM-YY');
  const formatDateTime = d =>
    moment(d, 'YYYY/MM/DD HH:mm:ss').format('DD-MMM-YY HH:mm');

  // Duplicated from ui/src/utils/formatUtils.ts::formatDurationHours - no shared
  // package between ui/ and app/ (same duplication pattern as CheckOutForm.tsx's
  // calculation helpers).
  const formatDurationHours = hours => {
    if (hours == null || isNaN(hours) || hours <= 0) return '0h';
    const totalMins = Math.round(hours * 60);
    const days = Math.floor(totalMins / 1440);
    const remMinsInDay = totalMins % 1440;
    const hrs = Math.floor(remMinsInDay / 60);
    const mins = remMinsInDay % 60;
    if (days > 0) {
      const parts = [`${days}d`];
      if (hrs > 0) parts.push(`${hrs}h`);
      if (mins > 0) parts.push(`${mins}m`);
      return parts.join(' ');
    }
    return mins > 0 ? `${hrs}h ${mins}m` : `${hrs}h`;
  };

  // co_days is a true day count always - derive Days/Hours label+value from
  // co_posting1's cd_rentaltype/cd_hours (backend now includes both) for
  // Hourly/Refreshment stays instead. A Day-2+ escalated Hourly stay can now
  // genuinely exceed 24h - roll over into days for display rather than printing a
  // bare hour count.
  const durationRow = (rdat.co_posting1 || []).find(
    v => v.cd_rentaltype === 'H' || v.cd_rentaltype === 'R',
  );
  const durationLabel = durationRow ? 'Hours' : 'Days';
  let stayDays = Number(rdat.co_days) || 0;
  if (stayDays <= 0 && rdat.co_arrival && rdat.co_depature) {
    const arr = moment(rdat.co_arrival);
    const dep = moment(rdat.co_depature);
    if (arr.isValid() && dep.isValid()) {
      const diff = dep.clone().startOf('day').diff(arr.clone().startOf('day'), 'days');
      stayDays = diff > 0 ? diff : 1;
    }
  }
  const finalStayDays = stayDays > 0 ? stayDays : 1;
  const durationDisplay = durationRow
    ? formatDurationHours(Number(durationRow.cd_hours) || 0)
    : String(finalStayDays);

  let html = `
    <html>
    <head>
    <style>
      body { font-family: Arial; font-size: 12px; padding: 10px; }
      img { width:100%; max-width:300px; height:100%; max-height:100px; }
      table { width: 100%; line-height: inherit; text-align: left; border-collapse: collapse; }
      th, td { border: 1px solid #000; padding: 5px; text-align: left; }
      th { background-color: #f2f2f2; }
      .center { text-align: center; }
    </style>
    </head>
    <body>
      <table>
        <tr class="top">
          <td colspan="4">
            <table style="border=0px;">
              <tr>
                <td>${dat1.cm_logo ? `<img src="${dat1.cm_logo}" alt="Logo" />` : `<b>${dat1.cm_name || ''}</b>`}</td>
                <td style="text-align:right">
                  <b>${dat1.cm_name}</b><br/>
                  ${dat1.cm_addr1}<br/>
                  ${dat1.cm_addr2},
                  ${dat1.cm_addr3}<br/>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr><td colspan="4" style="border-top:1px solid black; border-bottom:1px solid black; text-align:center"><b>INVOICE</b></td></tr>
        <tr><td><b>Name</b></td><td>${
          rdat.co_name
        }</td><td><b>Bill No</b></td><td>${rdat.co_no}</td></tr>
        <tr><td><b>Company</b></td><td>${
          rdat.co_cname
        }</td><td><b>Room No</b></td><td>${rdat.co_pax?.co_room}</td></tr>
        <tr><td><b>Address</b></td><td colspan="3">${rdat.co_addr1}<br/>${
    rdat.co_addr2
  }<br/>${rdat.co_city} - ${rdat.co_pincode}</td></tr>
        <tr><td><b>Bill Date</b></td><td>${formatDate(
          rdat.co_date,
        )}</td><td><b>Mobile</b></td><td>${rdat.co_mobile}</td></tr>
        <tr><td><b>Arrival</b></td><td>${formatDateTime(
          rdat.co_arrival,
        )}</td><td><b>Departure</b></td><td>${formatDateTime(
    rdat.co_depature,
  )}</td></tr>
        <tr><td><b>${durationLabel}</b></td><td>${durationDisplay}</td><td colspan="2">Male: ${
    rdat.co_pax?.co_male
  }, Female: ${rdat.co_pax?.co_female}, Child: ${
    rdat.co_pax?.co_child
  }</td></tr>
      </table>

      <h4>Room Charges</h4>
      <table>
        <tr><th>Date</th><th>Room</th><th>Tariff</th><th>EBed</th><th>Disc</th><th>CGST</th><th>SGST</th><th>FnB</th><th>Others</th><th>Total</th></tr>`;

  rdat.co_posting1?.forEach(v => {
    totTariff += Number(v.ps_tariff);
    totExtbed += Number(v.ps_extbed);
    totDisc += Number(v.ps_disc);
    totTax1 += Number(v.ps_tax1amt);
    totTax2 += Number(v.ps_tax2amt);
    totFnB += Number(v.ps_fnb);
    totOthers += Number(v.ps_others);
    tot += Number(v.ps_total);

    html += `<tr>
        <td>${formatDate(v.ps_date)}</td>
        <td>${v.ps_room}</td>
        <td style="text-align:right">${v.ps_tariff}</td>
        <td style="text-align:right">${v.ps_extbed}</td>
        <td style="text-align:right">${v.ps_disc}</td>
        <td style="text-align:right">${v.ps_tax1amt}</td>
        <td style="text-align:right">${v.ps_tax2amt}</td>
        <td style="text-align:right">${v.ps_fnb}</td>
        <td style="text-align:right">${v.ps_others}</td>
        <td style="text-align:right">${v.ps_total}</td>
      </tr>`;
  });

  html += `
      <tr>
        <td colspan="2"><b>Total</b></td>
        <td style="text-align:right">${totTariff.toFixed(2)}</td>
        <td style="text-align:right">${totExtbed.toFixed(2)}</td>
        <td style="text-align:right">${totDisc.toFixed(2)}</td>
        <td style="text-align:right">${totTax1.toFixed(2)}</td>
        <td style="text-align:right">${totTax2.toFixed(2)}</td>
        <td style="text-align:right">${totFnB.toFixed(2)}</td>
        <td style="text-align:right">${totOthers.toFixed(2)}</td>
        <td style="text-align:right">${tot.toFixed(2)}</td>
      </tr>
    </table>

    <h4>Advance Payments</h4>
    <table>
      <tr><th>Date</th><th>Receipt No</th><th>Amount</th></tr>`;

  rdat.co_advs?.forEach(v => {
    totAdv += Number(v.ca_amt);
    html += `<tr><td>${formatDate(v.ca_date)}</td><td>${
      v.ca_no
    }</td><td style="text-align:right">${Number(v.ca_amt).toFixed(
      2,
    )}</td></tr>`;
  });

  html += `<tr><td colspan="2"><b>Total Advance</b></td><td style="text-align:right">${totAdv.toFixed(
    2,
  )}</td></tr></table>`;

  const net = Math.round(tot - totAdv - (Number(rdat.co_commamt) || 0));

  html += `
    <h4>Summary</h4>
    <table>
      <tr><td><b>Net Amount</b></td><td style="text-align:right"><b>₹ ${net.toFixed(
        2,
      )}</b></td></tr>
    </table>

    <p style="text-align:center;margin-top:30px">Thank You. Visit Again.</p>
    </body></html>`;

  if (Platform.OS === 'web') {
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  } else {
    await RNPrint.print({html});
  }
}

